import { ClientOnly } from "remix-utils/client-only";
import Tippy from "@tippyjs/react";
import type { TippyProps } from "@tippyjs/react";
import { roundArrow } from "tippy.js";

export const Tooltip = (props: Omit<TippyProps, "arrow" | "theme">) => (
  <ClientOnly>
    {() => (
      <Tippy
        maxWidth="21rem"
        arrow={roundArrow}
        trigger="mouseenter"
        {...props}
      />
    )}
  </ClientOnly>
);
